export default {
  isAuthenticated(state) {
    return state.isAuthenticated;
  },

  candidateId(state) {
    return state.candidateId;
  },

  applications(state) {
    return state.applications;
  },

  mustAcceptInvitations(state) {
    return state.mustAcceptInvitations;
  },

  applicationsLoading(state) {
    return state.applicationsLoading;
  },

  loadFailed(state) {
    return state.loadFailed;
  },

  profile(state) {
    return state.profile;
  },

  profileLoading(state) {
    return state.profileLoading;
  },

  profileSaving(state) {
    return state.profileSaving;
  },

  profileError(state) {
    return state.profileError;
  }
};
